module.exports = __webpack_public_path__ + "static/artist-management-case-study-aadd18191e6bd78e51e559bc0962e8e0.webp";